<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="4">
          <b-form-group label="Von">
            <b-form-input type="date" v-model="fromStr" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Bis">
            <b-form-input type="date" v-model="toStr" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="d-flex align-items-end">
          <b-button :disabled="!fromStr || !toStr || loading" variant="primary" @click="loadCandidates">
            Kandidaten laden
          </b-button>
        </b-col>
      </b-row>

      <div class="my-2">
        <b-badge variant="info" class="mr-2">Ausgewählt: {{ selectedCustomers.length }}</b-badge>
        <b-button :disabled="selectedCustomers.length===0 || loading" variant="success" @click="startRun">
          Lauf starten
        </b-button>
      </div>

      <b-table
        striped
        hover
        responsive
        :items="rows"
        :fields="fields"
        :busy="loading"
        show-empty
        empty-text="Bitte Zeitraum wählen und 'Kandidaten laden' klicken."
        @row-clicked="toggleSelect"
      >
        <template #cell(select)="ctx">
          <b-form-checkbox :checked="isSelected(ctx.item.CustomerIdentId)" @change="toggleOne(ctx.item.CustomerIdentId)" />
        </template>
        <template #cell(Customer)="ctx">
          {{ ctx.item.CustomerNumber }} – {{ ctx.item.CustomerName }}
        </template>
        <template #cell(NetSum)="ctx">
          {{ money(ctx.item.NetSum) }}
        </template>
        <template #cell(CommissionSum)="ctx">
          {{ money(ctx.item.CommissionSum) }} ({{ ctx.item.Commission }}%)
        </template>
        <template #cell(PaymentMethod)="ctx">
        <b-badge :variant="ctx.item.PaymentMethod.variant">
          {{ ctx.item.PaymentMethod.label }}
        </b-badge>
      </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BButton,
  BTable, BFormCheckbox, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'InvoiceRunLocal',
  components: {
    BCard, BRow, BCol, BFormGroup, BFormInput, BButton,
    BTable, BFormCheckbox, BBadge,
  },
  data() {
    const today = new Date();
    const toISO = d => d.toISOString().slice(0,10);
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      fromStr: toISO(start),
      toStr: toISO(today),
      loading: false,
      rows: [],
      selectedCustomers: [],
      fields: [
        { key: 'select', label: '', thStyle: { width: '50px' } },
        { key: 'Customer', label: 'Kunde' },
        { key: 'VoucherCount', label: 'Fahrten' },
        { key: 'NetSum', label: 'Netto' },
        { key: 'CommissionSum', label: 'Provision' },
        { key: 'PaymentMethod', label: 'Zahlart' },
      ],
    }
  },
  methods: {    
    money(v) {
      try {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(v || 0);
      } catch { return v; }
    },
    toLocalDate(str) {
      // str = 'YYYY-MM-DD' -> Date (lokale TZ 00:00)
      const [y,m,d] = str.split('-').map(n => parseInt(n,10));
      return new Date(y, m-1, d);
    },
        async loadCandidates() {
        this.loading = true
        this.rows = []
        this.selectedCustomers = []
        try {
            const payload = { From: this.toLocalDate(this.fromStr), To: this.toLocalDate(this.toStr) }
            const resp = await this.$http.post('/invoice/searchVacantPositions', payload, { timeout: 60000 })
            if (resp.data && resp.data.success) {
                console.log("Run Response:", resp.data)
            const listObj = resp.data.list || {}
            this.rows = Object.values(listObj).map(x => ({
                ...x,
                PaymentMethod: this.mapPayment(x.PaymentMethod),
            }))
            this.$toast({
                component: ToastificationContent,
                props: {
                title: 'Kandidaten geladen',
                icon: 'CheckIcon',
                text: `Gefunden: ${this.rows.length} Kunden`,
                variant: 'info',
                },
            })
            } else {
            this.$toast({
                component: ToastificationContent,
                props: {
                title: 'Keine Daten',
                icon: 'AlertCircleIcon',
                text: 'Es wurden keine passenden Kandidaten gefunden.',
                variant: 'warning',
                },
            })
            }
        } catch (e) {
            console.error(e)
            this.$toast({
            component: ToastificationContent,
            props: {
                title: 'Fehler',
                icon: 'AlertTriangleIcon',
                text: 'Kandidaten konnten nicht geladen werden.',
                variant: 'danger',
            },
            })
        } finally {
            this.loading = false
        }
    },
    mapPayment(code) {
      const map = {
        0: { label: 'Keine Angabe', variant: 'secondary' },
        1: { label: 'Rechnung', variant: 'success' },
        2: { label: 'Lastschrift', variant: 'primary' },
        3: { label: 'Barzahlung (nur Provision)', variant: 'warning' },
      };
      return map[code] || { label: 'Unbekannt', variant: 'danger' };
    },
    isSelected(id) {
      return this.selectedCustomers.includes(id);
    },
    toggleOne(id) {
      if (this.isSelected(id)) {
        this.selectedCustomers = this.selectedCustomers.filter(x => x !== id);
      } else {
        this.selectedCustomers = [...this.selectedCustomers, id];
      }
    },
    toggleSelect(item) {
      this.toggleOne(item.CustomerIdentId);
    },
    async startRun() {
    this.loading = true;
    try {
        const payload = {
        Customers: this.selectedCustomers,
        CreditNoteCustomers: [],
        From: this.toLocalDate(this.fromStr),
        To: this.toLocalDate(this.toStr),
        };
        const resp = await this.$http.post('/invoice/localinvoice/createRun', payload, { timeout: 60000 });

        if (resp.data && resp.data.success) {
        const { count, created } = resp.data;

        // kurzer Erfolgstoast
        this.$bvToast.toast(
            count === 0
            ? 'Es wurden keine passenden Fahrten gefunden.'
            : `${count} lokale Rechnung(en) erstellt.`,
            {
            title: 'Lokaler Rechnungslauf',
            variant: count === 0 ? 'warning' : 'success',
            autoHideDelay: 3000,
            }
        );

        // Optional: erste Rechnung direkt öffnen
        if (created && created.length > 0) {
            // Beispiel: erstes PDF aufmachen
            const first = created[0];
            const url = `/invoice/localinvoice/pdf?id=${encodeURIComponent(first.id)}`;
            // Neue Tab-Ansicht
            this.$http.get(url, { responseType: 'blob' })
            .then(r => window.open(URL.createObjectURL(r.data)))
            .catch(() => {});
        }

        // zurück zur Übersicht
        this.$router.push({ name: 'BillingList' }).catch(()=>{});
        } else {
        this.$bvToast.toast('Konnte Lauf nicht starten.', {
            title: 'Fehler',
            variant: 'danger',
            autoHideDelay: 3500,
        });
        }
    } catch (e) {
        console.error(e);
        this.$bvToast.toast('Fehler beim Starten des Laufs.', {
        title: 'Fehler',
        variant: 'danger',
        autoHideDelay: 3500,
        });
    } finally {
        this.loading = false;
    }
    },
  },
}
</script>
